export class ReportSearchCriteria {
  reportName = null;
  showArchived = false;
  fetchAllRows = false;
  pageNumber = 1;
  pageSize = 16;
}
